import { Box, Grid2 as Grid, Typography } from '@mui/material';
import { DataGridLayout, List } from 'framework/list';
import { DateField, TextField, VersionField } from 'framework/ui/field';
import { DATE_FORMAT } from 'framework/utils';
import { ComplianceDocumentTargetAudienceField, ComplianceDocumentTypeField } from 'domain/shared/compliance';
import { ProjectSectionAccordion } from 'domain/shared/newProject';
import useProjectPoliciesData from './useProjectPoliciesData';

const ProjectPoliciesSection = () => {
  const { getDataMethod } = useProjectPoliciesData();

  return (
    <ProjectSectionAccordion
      defaultExpanded
      sx={{
        mb: 2.5,
        '& .MuiAccordionSummary-root': {
          pl: 2,
          pr: 1,
        },
        '& .MuiAccordionDetails-root': {
          pb: 2,
        },
      }}
      title={
        <Grid container direction="row" justifyContent="space-between" alignItems="center" width="100%" pl={2}>
          <Typography color="primary" variant="h4">
            Project policies
          </Typography>
        </Grid>
      }
    >
      <List getDataMethod={getDataMethod}>
        <Box pl={1}>
          <DataGridLayout isInitialLoaderPosition showPagination={false} showTotal={false}>
            <TextField width="22%" source="metadata.complianceName" label="Name" />
            <ComplianceDocumentTypeField width="17%" source="metadata.complianceType" label="Type" />
            <VersionField width="10%" source="metadata.version" label="Version" />
            <DateField width="14%" source="metadata.createdAt" label="Published on" dateFormat={DATE_FORMAT.SIMPLE} />
            <ComplianceDocumentTargetAudienceField
              width="32%"
              source="metadata"
              label="Target audience"
              coverageAssignmentsSource="currentProjectCoverageAssignments"
              displayAssignmentsSource="currentProjectViewAssignments"
            />
          </DataGridLayout>
        </Box>
      </List>
    </ProjectSectionAccordion>
  );
};

export default ProjectPoliciesSection;
